import React, { useCallback, useMemo, useState } from 'react'
import { AppTitlePage } from '../../../components/AppTitlePage'
import { AppBtnColor } from '../../../components/btn/AppBtn'
import { IChooseItems } from '../../../components/mainContent/TableAllDishes'
import { IPopup } from '../CategoriesPage/CategoriesPage'
import { AppFilterInput } from '../../../components/AppInput/AppFilterInput'
import { AppTable } from '../../../components/AppTable/AppTable'
import { useGetTagsListQuery } from '../../../core/api/TagsApi'
import { useParamsControl } from '../../../utils/useParamsControl'
import { ITag, ITagsRequestDto } from '../../../core/api/dto/TagsDto'
import { AddTagsPopup } from './components/AddTagsPopup'
import { AppDeleteFromMainServerPopup } from '../../../entities/AppDeleteFromMainServerPopup/AppDeleteFromMainServerPopup'
import { AppStationPopup } from '../../../entities/AppStationPopup/AppStationPopup'
import { useSentTagsOnFotobox } from './hooks/useSentTagsOnFotobox'
import { useDeleteTags } from './hooks/useDeleteTags'
import { AppFilterEdgeServersList } from '../../../entities/AppFilterEdgeServersList/AppFilterEdgeServersList'

const headerData = [{ title: 'Название', colWidth: '95%', sort: 'name' }]

export const TagsPage = () => {
  const pageParams = useParamsControl<ITagsRequestDto, keyof ITagsRequestDto>({
    withPagination: true,
    whiteList: ['search', 'ordering', 'edge_servers'],
  })
  const [openCreatePopup, setOpenCreatePopup] = useState<IPopup>({
    active: false,
    id: null,
  })
  const { data: tagList } = useGetTagsListQuery(
    { ...pageParams },
    { skip: !pageParams },
  )
  const [chooseItems, setChooseItems] = useState<IChooseItems | null>(null)
  const [tableData, setTableData] = useState<ITag[]>([])

  const {
    sentPopup,
    openSentPopup,
    onDeleteTagsStation,
    onSendTags,
    deleteStations,
    isDeleteMode,
    openDeleteStationPopup,
    closeSentPopup,
    isLoadingSend,
  } = useSentTagsOnFotobox({
    tableData,
    chooseItems,
    setChooseItems,
  })
  const {
    deletePopup,
    closeDeletePopup,
    onDeletePopupHandler,
    onDeleteHandler,
  } = useDeleteTags(chooseItems, setChooseItems)

  const openEditPopupHandler = useCallback(
    (id: number) => setOpenCreatePopup({ id, active: true }),
    [],
  )

  const closePopupHandler = useCallback(
    () => setOpenCreatePopup({ id: null, active: false }),
    [],
  )

  const tableActions = [
    {
      title: 'Удалить',
      ico: 'basket',
      onClick: onDeletePopupHandler,
    },
    ...(process.env.REACT_APP_TYPE_SERVER === 'MainServer'
      ? [
          {
            title: 'Отправить на станцию',
            ico: 'add',
            onClick: openSentPopup,
          },
        ]
      : []),
  ]
  const actions = useMemo(
    () => [
      {
        btnTitle: 'Добавить хэштег',
        btnIco: 'add',
        onClick: () =>
          setOpenCreatePopup((prevState) => ({ ...prevState, active: true })),
        color: AppBtnColor.whiteOutlineViolet,
      },
    ],
    [],
  )

  if (!tagList) {
    return null
  }

  return (
    <React.Fragment>
      {openCreatePopup.active && (
        <AddTagsPopup id={openCreatePopup.id} closePopup={closePopupHandler} />
      )}
      {deletePopup && (
        <AppDeleteFromMainServerPopup
          onClose={closeDeletePopup}
          onDelete={onDeleteHandler}
          onOpenStationPopup={openDeleteStationPopup}
        />
      )}
      {sentPopup && (
        <AppStationPopup
          onClose={closeSentPopup}
          isLoading={isLoadingSend}
          onSendItems={onSendTags}
          isDeleteMode={isDeleteMode}
          deleteStations={deleteStations}
          onDeleteStationDishes={onDeleteTagsStation}
        />
      )}
      <div className="width-for-page-wrapper">
        <AppTitlePage title="Хэштеги" actions={actions} />
        <div className="col-7-width-from-1000">
          <div className="filter-block no-wrap mt-20">
            <AppFilterInput
              fullWidth
              searchParam={'search'}
              ico={'search'}
              label={'Поиск'}
              placeholder="Поиск: #"
            />
            <AppFilterEdgeServersList fullWidth />
          </div>
          <AppTable
            data={tagList}
            headerData={headerData}
            chooseItems={chooseItems}
            chooseMode
            setChooseItems={setChooseItems}
            idName="tags"
            setTableData={setTableData}
            tableDataSelectors={[
              {
                renderItem: (item) => (
                  <div
                    className={`table-link ${
                      item.archived ? 'delete-item' : ''
                    }`}
                    onClick={() => openEditPopupHandler(item.id)}
                  >
                    {item.name}
                  </div>
                ),
              },
            ]}
            chooseActions={tableActions}
          />
        </div>
      </div>
    </React.Fragment>
  )
}
